import NAME from "./constants";

export const getIsLoading = store => store[NAME].isLoading;
export const getKPIData = store => store[NAME].kpiData;